export default "__VITE_ASSET__d42ef2c8__"